import { HistoryTimeline } from "../../components";
import { useGetQuoteHistory } from "../../hooks/react-query/useSalesData";
import { QUOTE_STAGE_LABELS } from "../../constants/salesStages";

const getStageLabel = (stage) =>
  QUOTE_STAGE_LABELS.find((s) => s.id === stage)?.label || `Stage ${stage}`;

const getStageFlow = (stage) =>
  QUOTE_STAGE_LABELS.find((s) => s.id === stage)?.flow || "grey";

const QuoteTimeline = ({ quoteId }) => {
  const { data: history } = useGetQuoteHistory(quoteId);

  return (
    <HistoryTimeline
      history={history || []}
      getStageLabel={getStageLabel}
      getStageFlow={getStageFlow}
    />
  );
};

export default QuoteTimeline;
